import { environment } from 'src/environments/environment';
// import { environment } from './../../environments/environment.prod';
export class Urls {
    keycloakUrl = environment.keycloakUrl;
    baseUrl = environment.baseUrl;
    appUrl = environment.appUrl;
    usmUrl = environment.usmUrl;
}
